
<template>
	<div class="container">
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">数据监测</el-breadcrumb-item>
			<el-breadcrumb-item>用能数据</el-breadcrumb-item>
		</el-breadcrumb>


		<el-row :gutter="20" ref="outBox">
			<el-col :span="18">
				<!-- 搜索筛选 -->
				<el-form :inline="true" class="user-search" label-position="left" label-width="80px">
					<el-form-item>
						<el-date-picker @change="getTime" size="small" v-model="timeDatas" type="datetimerange" range-separator="至"
						 start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>

					<!-- <el-form-item>
						<el-select size="small" v-model="datatype" placeholder="选择表码">
							<el-option></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select size="small" v-model="datatype" placeholder="费率类型">
							<el-option></el-option>
						</el-select>
					</el-form-item>-->
					<el-form-item>
						<!-- <el-button size="small" type="primary" :loading="loading" icon="el-icon-search" @click="getYndata">搜索</el-button> -->
						<el-button size="small"  type="success" icon="el-icon-download" :loading="downloadLoadin" @click="exportdata">导出</el-button>
					</el-form-item>
					<el-form-item style="float: right;">
						<!-- <el-button size="small" type="success" icon="el-icon-download">导出</el-button> -->
						<!-- <el-button size="small" type="infor" icon="el-icon-refresh">刷新</el-button> -->
					</el-form-item>
				</el-form>
				<el-table size="small" :data="listData" ref="chaobTable" :max-height="tableHeight" highlight-current-row v-loading="loading"
				 border element-loading-text="拼命加载中" style="width: 100%;" stripe :header-cell-style="this.$store.state.headerCss" >
					<el-table-column align="center" type="index" width="60" label="序号">

					</el-table-column>
					<el-table-column show-overflow-tooltip prop="meterPointName" width="200" sortable  label="计量点名称"></el-table-column>
					<!-- <el-table-column show-overflow-tooltip prop="meterPoint"  label="计量点地址"></el-table-column> -->

					<el-table-column show-overflow-tooltip prop="rate" width="80" label="费率" v-if="formInline.energyType == '15'"></el-table-column>

					<el-table-column show-overflow-tooltip prop="startCode"  label="起码" sortable></el-table-column>
					<el-table-column show-overflow-tooltip prop="endCode"  label="止码" sortable></el-table-column>
					<el-table-column show-overflow-tooltip prop="magnification"  width="80"  label="倍率" sortable></el-table-column>
					<el-table-column show-overflow-tooltip prop="code"  label="能耗" sortable></el-table-column>

					<!-- <el-table-column align="center" label="倍率"></el-table-column> -->
					<!-- <el-table-column align="center" label="电量"></el-table-column> -->
					<el-table-column  prop="startCodeTime" width="150" label="起码时间"></el-table-column>
					<el-table-column  prop="endCodeTime" width="150" label="止码时间"></el-table-column>

				</el-table>
			</el-col>
			<el-col :span="6">

				<el-popover v-model="visible" @show="setWidth">
					<el-input ref="deptInput" class="cp" readonly slot="reference" autosize size="small" value="" placeholder="选择部门/集中器"
					 v-model="getJZ"></el-input>
					<div :style="{ width: pW}">
						<el-tree v-loading="treeLoad" :data="treeDate" :expand-on-click-node="false" :highlight-current="true"
						 @node-click="handleNodeClick" :props="jzProps" accordion node-key='id'>
							<span class="custom-tree-node" slot-scope="{ node, data }">
								<span>
									<i v-if="!data.parentId && !data.isJz" class="el-icon-office-building"></i>
									<i v-if="data.parentId" class="el-icon-location-outline"></i>
									<i v-if="data.isJz" class="el-icon-coin"></i>
									{{ data.departmentName }}
								</span>
							</span>
						</el-tree>
					</div>
				</el-popover>
				<el-select size="small" v-model="formInline.energyType" @change="changeEnergy" placeholder="能源类别" style="width: 100%;margin-top: 10px;">
					<el-option v-for="item in energyTypeList" :key="item.id" :label="item.value" :value="item.id">
					</el-option>
				</el-select>
        <div style="margin-top: 10px; display: flex;">
          <el-input placeholder="请输入计量点地址" @keyup.enter.native="handJlSearch"  size="small" v-model="formInline.meterPoint"></el-input>
         
        </div>
        <div style="margin-top: 10px; display: flex;">
          <el-input placeholder="请输入计量点名称" @keyup.enter.native="handJlSearch"  size="small" v-model="formInline.meterPointName"></el-input>
          <el-button size="small" type="primary" style="margin-left: 10px;"  @click="handJlSearch">搜索</el-button>
        </div>
				<div style="margin-top: 10px;">
					<el-table ref="jltable" size="small" border :data="jlData" v-loading="loadJl" :height="tableHeightLeft"
					 @selection-change="handleSelectionChange" :header-cell-style="this.$store.state.headerCss">

						<!-- <el-table-column type="selection"  width="50"></el-table-column> -->
						<el-table-column  label="计量点名称"  prop="meterPointName"></el-table-column>
						<el-table-column label="用能单位"  prop="terminalInfoName"></el-table-column>
						<!-- <el-table-column label="计量点名称" prop="jlName" ></el-table-column> -->
					</el-table>
				</div>
				<!-- 分页组件 -->
				<el-pagination


        @size-change="handleSizeChange"
        layout="prev, pager, next,sizes"
        :total="pageparm.total"
        :page-size="pageparm.pageSize"
        :pager-count="5"
        :page-sizes="[ 30, 50, 100, 200,300,500]"
        style="margin-top: 20px;"
				 @current-change="handleCurrentChange"
         v-if="showPage">
				</el-pagination>
			</el-col>
		</el-row>

		<!-- 编辑界面 -->
		<!-- <el-dialog :visible.sync="editFormVisible"  @click="closeDialog">
			<div class="paybox">
				<div class="cavasbox" ref="fengLei"></div>
			</div>
			<el-table size="small" border  height="250">
				<el-table-column type="index" label="序号" width="60px"></el-table-column>
				<el-table-column label="计量点"></el-table-column>
				<el-table-column label="用能单位"></el-table-column>
				<el-table-column label="采集时间"></el-table-column>
				<el-table-column label="费率"></el-table-column>
				<el-table-column label="正向有功表码"></el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeDialog">确认</el-button>

			</div>
		</el-dialog> -->
	</div>
</template>

<script>
	import Chart from 'echarts'
	import 'echarts/theme/macarons.js'
	import {
		getAllConfigurationList,
		getDepartmentTerminalInfoLis,
		findMeterInfoList,
		getMeterReadingData,
		getTerminalInfoByDepId,
		getMeterEnergyData,
		getMeterEnergyDataPoiFiter
	} from '../../api/energyMG'
	import {
		timestampToTime
	} from '@/utils/util'
	import Pagination from '../../components/Pagination'
	export default {
		data() {
			return {
				tableHeight: 0,
				tableHeightLeft: 0,
				visible: false,
				dates: '',
				datatype: '',
				getJZ: "",
				loading: true, //是显示加载
				editFormVisible: false, //控制编辑页面显示与隐藏
				title: '添加',
				treeDate: [

				],
				pW: "",
        showPage:true,
				editForm: {
					deptId: '',
					deptName: '',
					deptNo: '',
					token: localStorage.getItem('logintoken')
				},
				// rules表单验证
				rules: {
					deptName: [{
						required: true,
						message: '请输入部门名称',
						trigger: 'blur'
					}],
					deptNo: [{
						required: true,
						message: '请输入部门代码',
						trigger: 'blur'
					}]
				},
				jlData: [],
				jzProps: {
					label: "departmentName",
					children: 'deps'

				},
				formInline: {
					energyType: "",
          meterPoint:"",
          isRunning:"",
					terIds: JSON.stringify([]),
					meterPointName: '',
					currentPage: 1,
					pageSize: 30,
				},

				formYnData: {
					startTime: "",
					endTime: "",
					meterPointInfoIds: JSON.stringify([]),
					dataItem: ""
				},
				downloadLoadin: false,

				// 删除部门
				seletedata: {
					ids: '',
					token: localStorage.getItem('logintoken')
				},
				energyTypeList: [], //能源数据
				timeDatas: [],
				listData: [], //用户数据
				// 分页参数
				pageparm: {
					currentPage: 1,
					pageSize: 30,
					total: 0
				},
				treeLoad: true,
				loadJl: true,
				z_option: {

					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: ['正相有工表码'],

					},

					calculable: true,
					xAxis: [{
						type: 'category',
						data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
					}],
					yAxis: [{
						type: 'value',

					}],
					series: [{
						name: '正相有工表码',
						type: 'line',
						data: [0.5, 0.35, 0.52, 0.7, 0.57, 0.6, 0.64, 0.43, 0.7, 0.53, 0.42, 0.9]

					}]
				},
			}
		},
		// 注册组件
		components: {
			Pagination
		},
		/**
		 * 数据发生改变
		 */

		/**
		 * 创建完毕
		 */
		created() {
			this.getChoisedate();
			this.initData();
		},
		mounted() {

			this.$nextTick(() => {

				// let out = this.$refs.chaobTable.$el.offsetTop + this.$refs.outBox.$el.offsetTop
				this.tableHeight = window.innerHeight - 175-60
				this.tableHeightLeft = window.innerHeight - 240 - 120
				//window.innerHeight
			})

		},

		/**
		 * 里面的方法只有被调用才会执行
		 */
		methods: {


			exportdata() {
				this.downloadLoadin = true
				let param = { ...this.formInline,...this.formYnData}
				getMeterEnergyDataPoiFiter(param).then(res => {

					var blob = new Blob([res], {
						type: 'application/vnd.openxmlformats-  officedocument.spreadsheetml.sheet;charset=utf-8'
					}); //type这里表示xlsx类型
					var downloadElement = document.createElement('a');
					var href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					downloadElement.download = 'result.xls'; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放掉blob对象

					this.downloadLoadin = false

				}).catch(err => {
					this.downloadLoadin = false
					this.$message({
						message: '下载失败！',
						type: 'error',
						showClose: true
					})
				})

			},
			getChoisedate() {
				let date = new Date();
				let year = date.getFullYear();
				let month = date.getMonth();
				let strDate = date.getDate();
				this.timeDatas = [new Date(year, month, strDate-1, 0, 0), new Date(year, month, strDate,0,0)]

				this.formYnData.startTime = timestampToTime(new Date(year, month, strDate-1))
				this.formYnData.endTime = timestampToTime(new Date(year, month, strDate))
				// this.timeDatas = [ new Date(year, month, strDate, 00, 00), new Date(year, month, strDate, 23, 59) ]
			},

			getTime(e) {
				this.formYnData.startTime = timestampToTime(this.timeDatas[0])
				this.formYnData.endTime = timestampToTime(this.timeDatas[1])
			},
			handleSelectionChange(e) {

			},
			handleCurrentChange(e) {
				this.pageparm.currentPage = e
				this.formInline.currentPage = e
				this.getJlData()
			},
      handleSizeChange(val){
        this.pageparm.pageSize = val
        this.formInline.pageSize = val
        this.getJlData()
      },
			async initData() {
				await this.getConfigData(); //获取配置
				await this.getJzData(); //集中器
				await this.getJlData(); //计量点
				this.getYndata(); //用能数据

			},
			async changeEnergy(val) {
				this.formInline.energyType = val
				await this.getJlData(); //计量点
				//this.getYndata();
			},
			handJlSearch() {
				this.formInline.currentPage = 1
        this.showPage = false

				this.getJlData()
        this.$nextTick(()=>{
          this.showPage = true
        })
			},
			handleNodeClick(data) {

				this.getJZ = data.departmentName
				if (data.isJz) {
					let idstr = JSON.stringify([{
						id: data.id
					}])
					this.formInline.terIds = idstr

				} else {
					//点击部门获得集中器id
					getTerminalInfoByDepId({
						depId: data.id
					}).then(res => {

						if (res.status == 1) {
							let arr = []
							res.data.forEach(item => {
								let obj = {}
								obj.id = item
								arr.push(obj)
							})


							this.formInline.terIds = JSON.stringify(arr)
						} else {
							this.$message.error(res.msg)
						}
					})
				}
				this.visible = false
				//this.getJlData()

			},

			//获取所有配置选项
			getConfigData: function() {
				getAllConfigurationList().then(res => {
					if (res.status == 1) {
						this.energyTypeList = res.data.energyType
						this.formInline.energyType = this.energyTypeList[0].id
					} else {
						this.$message.error(res.msg)
					}
				})

			},


			//获取集中器信息
			getJzData: function() {
				return new Promise((resolve, reject) => {
					getDepartmentTerminalInfoLis().then(res => {
						this.treeLoad = false
						if (res.status == 1) {
							let arr = []
							this.treeDate = this.changeData(res.data.menuDepList)
							res.data.terIds.forEach(item => {
								let obj = {}
								obj.id = item
								arr.push(obj)
							})
							this.formInline.terIds = JSON.stringify(arr)
							resolve(res.data.terIds)
						} else {
							this.$message.error(res.msg)
						}
					})
				})

			},

			//获取计量点信息
			getJlData: function() {
				this.loadJl = true
				let param = this.formInline
				return new Promise((resolve, reject) => {
					findMeterInfoList(param).then(res => {
							if (res.status == 1) {
								this.loadJl = false
								this.jlData = res.data.data
								this.pageparm.currentPage = this.formInline.currentPage
								this.pageparm.pageSize = this.formInline.pageSize
								this.pageparm.total = res.data.totalCount
								let arr = this.jlData.map(item => {
									return {
										id: item.id
									}
								})

								// 	this.formYnData.meterPointInfoIds = JSON.stringify(arr)
								//
								// resolve(JSON.stringify(arr) )
								return JSON.stringify(arr)
							} else {
								this.loadJl = false
								this.$message.error(res.msg)
							}
						})
						.then(result => {
							this.formYnData.meterPointInfoIds = result
							//this.$nextTick( ()=> {
							// this.$refs.jltable.toggleAllSelection();
							//})
							this.getYndata();
						})
				})

			},
			callFather() {

			},

			//获取用能数据列表
			getYndata() {
				let param = { ...this.formInline,
					...this.formYnData
				}
				this.loading = true
				getMeterEnergyData(param).then(res => {

					this.loading = false
					if (res.status == 1) {
						this.listData = res.data.result
					}else{
						this.listData = []
					}
				})
			},
			setWidth(e) {
				this.pW = this.$refs.deptInput.$el.offsetWidth - 30 + 'px'
			},
			changeData(data) {
				data.forEach(item => {
					if (item.terminalInfo) {
						if (!item.deps) {
							item.deps = []
						}
						item.terminalInfo.forEach(sitem => {
							let obj = {}
							obj.id = sitem.id
							obj.departmentName = sitem.terminalName
							obj.terminalCode = sitem.terminalCode
							obj.isJz = true
							item.deps.push(obj)
						})
					}

					if (item.deps) {
						this.changeData(item.deps)
					}
				})

				return data
			},
		}
	}
</script>

<style>
	.user-search {}

	.userRole {
		width: 100%;
	}

	.cavasbox {
		box-sizing: border-box;
		width: 100%;
		height: 100%;
	}

	.paybox {
		width: 100%;
		background-color: #fff;
		box-sizing: border-box;
		border-radius: 5px;

		height: 32vh;
	}
  .el-popover{
    max-height: 260px !important;
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/views/datamonitoring/energyData.vue